<template>
    <v-card>
        <v-form ref="treatmentForm" lazy-validation>
            <v-card-title>
                <span class="headline" v-if="this.id == null">Ajouter un traitement</span>
                <span class="headline" v-else>Traitement</span>
            </v-card-title>
            <v-card-text>
                <v-container grid-list-md>
                    <v-layout wrap>
                        <v-flex xs12 v-if="this.id == null || !this.hasFollowup">
                            <v-menu v-model="showDatePicker"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    max-width="290px"
                                    min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="dateFormatted"
                                        label="Date de l'intervention"
                                        append-icon="event"
                                        v-on="on"
                                        :rules="[v => !!v || 'Le champs est requis']"
                                        @blur="intervention_date = parseDate(dateFormatted)"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="intervention_date" no-title locale="fr"
                                               @input="showDatePicker = false"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs12>
                            <v-select
                                v-if="canUpdate || true"
                                :value="type"
                                :rules="[v => !!v || 'Le champs est requis']"
                                :items="getTreatmentTypeOptions"
                                @change="(value) => { setType(value) }"
                                label="Traitement"
                                required
                            ></v-select>
                            <template v-else><span class="subheading">Traitement :</span> {{ getText(type) }} </template>
                        </v-flex>
                        <v-flex v-if="type && hasSubTypes(type)" xs12>
                            <v-select
                                v-if="canUpdate || true"
                                :value="subType"
                                :rules="[v => !!v || 'Le champs est requis']"
                                :items="getTreatmentSubTypeOptions[type]"
                                @change="(value) => { setSubType(value) }"
                                label="Type"
                                required
                            ></v-select>
                            <template v-else-if="subType"><span class="subheading">Type :</span> {{ getText(subType) }} </template>
                        </v-flex>
                        <v-flex v-if="type && ['TREATMENT_FULL_KNEE_REPLACEMENT', 'TREATMENT_PARTIAL_KNEE_REPLACEMENT', 'TREATMENT_SURGERY'].includes(type)" xs12>
                            <v-select
                                v-if="canUpdate || true"
                                :value="surgerySide"
                                :rules="[v => !!v || 'Le champs est requis']"
                                :items="getTreatmentSurgerySideOptions[type]"
                                @change="(value) => { setSurgerySide(value) }"
                                label="Coté opéré"
                                required
                            ></v-select>
                            <template v-else-if="surgerySide"><span class="subheading">Coté opéré :</span> {{ getText(surgerySide) }} </template>
                        </v-flex>

                        <v-flex xs12>
                            <v-select
                                v-if="(canUpdate || true) && surgerySide === 'BOTH'"
                                :value="relatedTreatmentId"
                                :items="aLlRelatedTreatments"
                                @change="(value) => { setRelatedTreatmentId(value) }"
                                label="Traitement lié"
                                required
                            ></v-select>
                            <template v-if="!(canUpdate || true) && surgerySide === 'BOTH'"><span class="subheading">Traitement lié :</span> {{ getTreatmentName(relatedTreatmentId) }} </template>
                        </v-flex>

                        <v-flex xs12>
                            <div v-if="canUpdate || true">
                                <v-label>Participe aux études :</v-label>

                                <v-checkbox
                                    v-for="item in filteredStudies"
                                    :key="item.id"
                                    hide-details
                                    v-model="participantStudies"
                                    :disabled="!!item.block_new_patient"
                                    :value="item"
                                    :label="item.name">
                                </v-checkbox>
                            </div>
                            <template v-else><span class="subheading">Etude(s) concernée(s) :</span>
                                <span v-for="(item, index) in participantStudies">{{ item.name + (index < participantStudies.length - 1 ? ', ' : '')}}</span>
                            </template>
                        </v-flex>

                        <v-flex xs12 v-if="this.id">
                            <v-label>Resurfaçage rotule</v-label>
                            <v-radio-group v-model="resurfacing" row
                                           validate-on-blur>
                                <v-radio label="Oui" :value="1"></v-radio>
                                <v-radio label="Non" :value="0"></v-radio>
                            </v-radio-group>
                        </v-flex>
                        <v-flex xs12 v-if="this.id">
                            <v-label>Alignement</v-label>
                            <v-radio-group v-model="alignment" row
                                           validate-on-blur>
                                <v-radio label="Mécanique" value="ALIGNMENT_MECHANIC"></v-radio>
                                <v-radio label="Cinématique" value="ALIGNMENT_CINEMATIC"></v-radio>
                            </v-radio-group>
                        </v-flex>
                        <v-flex xs12 v-if="this.id">
                            <v-label>Genou déjà opéré</v-label>
                            <v-radio-group v-model="alreadyOperated" row
                                           validate-on-blur>
                                <v-radio label="Oui" :value="1"></v-radio>
                                <v-radio label="Non" :value="0"></v-radio>
                            </v-radio-group>
                        </v-flex>

                        <v-flex xs12>
                            <v-textarea v-model="description" label="Description" required></v-textarea>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" @click="close">Annuler</v-btn>
                <v-btn color="primary" @click="save">Enregistrer</v-btn>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
import {mapActions, mapState, mapMutations, mapGetters} from 'vuex'
    import {getTranslationString} from "../../../helper";

    export default {
        name: "TreatmentForm",
        data() {
            return {
                showDatePicker: false,
                dateFormatted: '',
            }
        },
        created() {
            this.getActiveStudies()
        },
        computed: {
            ...mapGetters('medical_cases', {
                getMedicalCaseRelatedTreatments: 'getRelatedTreatments',
            }),
            ...mapGetters('treatments', ['getRelatedTreatments', 'getTreatmentName', 'getTreatmentTypeOptions', 'getTreatmentSubTypeOptions', 'getTreatmentSurgerySideOptions']),
            ...mapState('studies', {
                activeStudies: state => state.active

        }),
            filteredStudies: {
                get() {
                    return this.activeStudies.filter(study =>
                        !study.block_new_patient ||
                        this.participantStudies?.some((s) => s.id === study.id)
                    );
                }
            },
            aLlRelatedTreatments: {
                get() {
                    return this.id ? this.getRelatedTreatments : this.getMedicalCaseRelatedTreatments
                }
            },
            hasFollowup: {
                get() {
                    return this.$store.state.treatments.selectedTreatment.follow_ups
                    && this.$store.state.treatments.selectedTreatment.follow_ups.length > 1
                }
            },
            canUpdate: {
                get() {
                    return !(this.id && this.$store.state.treatments.selectedTreatment.follow_ups
                        && this.$store.state.treatments.selectedTreatment.follow_ups.length > 0)
                }
            },
            intervention_date: {
                get() {
                    return this.$store.state.treatments.form.intervention_date
                },
                set(value) {
                    this.setInterventionDate(value)
                }
            },
            participantStudies: {
                get() {
                    return this.$store.state.treatments.form.studies
                },
                set(value) {
                    this.setParticipantStudy(value)
                }
            },
            type: {
                get() {
                    return this.$store.state.treatments.form.type
                },
                set(value) {
                    this.setType(value)
                }
            },
            subType: {
                get() {
                    return this.$store.state.treatments.form.sub_type
                },
                set(value) {
                    this.setSubType(value)
                }
            },
            surgerySide: {
                get() {
                    return this.$store.state.treatments.form.surgery_side
                },
                set(value) {
                    this.setSurgerySide(value)
                }
            },
            relatedTreatmentId: {
                get() {
                    return this.$store.state.treatments.form.related_treatment_id
                },
                set(value) {
                    this.setRelatedTreatmentId(value)
                }
            },

            description: {
                get() {
                    return this.$store.state.treatments.form.description
                },
                set(value) {
                    this.setDescription(value)
                }
            },
            resurfacing: {
                get() {
                    return this.$store.state.treatments.form.resurfacing
                },
                set(value) {
                    this.setResurfacing(value)
                }
            },
            alignment: {
                get() {
                    return this.$store.state.treatments.form.alignment
                },
                set(value) {
                    this.setAlignment(value)
                }
            },
            alreadyOperated: {
                get() {
                    return this.$store.state.treatments.form.already_operated
                },
                set(value) {
                    this.setAlreadyOperated(value)
                }
            },
            id: {
                get() {
                    return this.$store.state.treatments.form.id
                },
                set(value) {
                    this.setId(id)
                }
            }
        },
        methods: {
            save() {
                this.$store.state.treatments.form.id == null ? this.create() : this.update();
            },
            create() {
                if (this.$refs.treatmentForm.validate()) {
                    this.createTreatment().then(response => {
                        this.getMedicalCaseInfo();
                        this.setShowForm(false);
                    }).catch(reason => {
                        //Stay here..
                    })
                }
            },
            close() {
                this.setShowForm(false)
            },
            update() {
                this.updateTreatment().then(response => {
                    this.getTreatmentInfo();
                    this.setShowForm(false);
                }).catch(reason => {
                    //Stay here..
                })
            },
            getText(key) {
                return getTranslationString(key)
            },
            hasSubTypes(type) {
                return this.getTreatmentSubTypeOptions[type] && this.getTreatmentSubTypeOptions[type].length > 0
            },
            parseDate (date) {
                if (!date) return null

                const [day, month, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            ...mapMutations('treatments', {
                setType: 'setFormType',
                setSubType: 'setFormSubType',
                setParticipantStudy: 'setFormParticipantStudy',
                setSurgerySide: 'setFormSurgerySide',
                setRelatedTreatmentId: 'setFormRelatedTreatmentId',
                setInterventionDate: 'setFormInterventionDate',
                setDescription: 'setFormDescription',
                setResurfacing: 'setFormResurfacing',
                setAlignment: 'setFormAlignment',
                setAlreadyOperated: 'setFormAlreadyOperated',
                setId: 'setFormId',
                setShowForm: 'setShowForm',
            }),
            ...mapActions('treatments', ['createTreatment', 'updateTreatment', 'getTreatmentInfo']),
            ...mapActions('medical_cases', ['getMedicalCaseInfo']),
            ...mapActions('studies', [
                'getActiveStudies'
            ]),
        },
        watch: {
            intervention_date(date) {
                this.dateFormatted = date ? this.$options.filters.formatedDate(date) : ''
            }
        }
    }
</script>
